import image1 from '../assets/images/avatar/avatar-01.png';
import image2 from '../assets/img/pixlr-image-generator-0807d7a4-8d0e-4c37-8277-bda83947299c (1).png';
import image3 from '../assets/img/pixlr-image-generator-0807d7a4-8d0e-4c37-8277-bda83947299c (1).png';

export const categories = [
  {
    id: 1,
    link: "#",
    text: "Soft skills",
  },
  {
    id: 2,
    link: "#",
    text: "Technical skills",
  },
];

export const products = [
  {
    id: 1,
    src: image2,
    title: "Mohamed koumenji",
    price: "Node js Trainer",
    delay: "0s",
  },
  {
    id: 2,
    src: image3,
    title: "Ahmed bousselmi",
    price: "3d Unity Trainer",
    delay: "0.1s",
  },
  {
    id: 3,
    src: image2,
    title: "Yessin Rebhi",
    price: "React js Trainer",
    delay: "0.2s",
  },
  {
    id: 4,
    src: image2,
    title: "Adem Neji",
    price: "Data science Trainer",
    delay: "0s",
  },
];
